import type * as types from "../lib/types";
import { Avatar, AvatarFallback } from "./ui/avatar";

interface CharacterItemProps {
  character: types.Character;
  onClick: () => void;
}

export function CharacterItem({ character, onClick }: CharacterItemProps) {
  return (
    <div
      className="flex items-center space-x-4 p-3 hover:bg-gray-100 rounded-lg cursor-pointer transition-colors"
      onClick={onClick}
    >
      <Avatar className="w-12 h-12">
        <AvatarFallback>{character.name.slice(0, 2).toUpperCase()}</AvatarFallback>
      </Avatar>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-medium text-gray-900 truncate">{character.name}</h3>
        <p className="text-xs text-gray-500 truncate">{character.unique_name}</p>
      </div>
    </div>
  );
}
